/**
 * Tipos y helpers de los datos bancarios de ATSA — ADR #042
 *
 * Cuenta única del Banco de la Nación Argentina para pago por transferencia,
 * usada mientras Pronto Pago no pueda generar CVUs. Se guarda en `parametros`
 * (claves `banco_*`).
 */

export interface DatosBancarios {
  razonSocial: string;
  cuit: string;
  banco: string;
  cuenta: string;
  cbu: string;
  alias: string;
}

/**
 * Arma los datos bancarios desde filas { clave, valor } de `parametros`.
 * Devuelve null si falta el CBU o el alias (sin ellos no hay a dónde pagar).
 */
export function parametrosToDatosBancarios(
  filas: Array<{ clave: string; valor: string }>,
): DatosBancarios | null {
  const map = new Map(filas.map((f) => [f.clave, (f.valor ?? '').trim()]));
  const cbu = map.get('banco_cbu') ?? '';
  const alias = map.get('banco_alias') ?? '';
  if (!cbu || !alias) return null;
  return {
    razonSocial: map.get('banco_razon_social') ?? '',
    cuit: map.get('banco_cuit') ?? '',
    banco: map.get('banco_nombre') ?? '',
    cuenta: map.get('banco_cuenta') ?? '',
    cbu,
    alias,
  };
}
